import { Theme } from 'config';

const styles = (theme: Theme) => ({
  mainHeader: {
    color: '#585858 !important',
    margin: '1.5em 0 2.25em 0 !important',
    fontSize: '1.125em !important',
    background: '#f7f7f7',
  },
  noPadding: {
    padding: '0 !important',
  },
  title: {
    margin: '0 0 1em 0 !important',
    color: `${theme.violet} !important`,
  },
  grid: {
    background: '#fff !important',
    padding: '4em 2em !important',
    boxShadow:
      '0 0.0625em 0 0 rgba(0,0,0,0.03), 0 0.125em 0.375em 0 rgba(0,0,0,0.06)',
  },
  childrenBlock: {
    margin: '1rem 0 !important',
  },
  ref: {
    width: '100%',
    padding: '0 !important',
  },
  statSig: {
    padding: '0 !important',
    color: `${theme.darkGray} !important`,
  },
});

export default styles;
